<template>
  <Modal
    class="game-log"
    v-if="modals.gameLog && session.sessionId && !session.isSpectator"
    @close="toggleModal('gameLog')"
  >
    <h3>Game Log</h3>

    <template v-if="!session.isSpectator">
      <div class="options">
        <div class="option" @click="resetGameLog">
          <font-awesome-icon icon="trash-alt" />
          Clear
        </div>
      </div>
    </template>
    <div class="log-wrapper">
      <p v-for="(line, index) in session.gameLog" :key="index" class="log-message" :class="'type-' + line.type">
        <font-awesome-icon fixed-width :icon="icons[line.type]"></font-awesome-icon> <strong>{{
          line.time
            .getHours()
            .toString()
            .padStart(2, "0")
        }}:{{
          line.time
            .getMinutes()
            .toString()
            .padStart(2, "0")
        }}: </strong> {{line.text}}
      </p>
    </div>
    <div class="controls">
      <input v-model="customNote" type="text" class="customNoteInput" placeholder="Your Custom notes..." @keyup.enter="storeNote()" />
      <div class="button-group button-group-small">
      <span class="button" v-on:click="storeNote()">+</span>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "./Modal";
import { mapMutations, mapState } from "vuex";

export default {
  components: {
    Modal
  },
  computed: {
    ...mapState(["session", "modals", "grimoire"])
  },
  data() {
    return {
      customNote: "",
      icons: {
        custom: "comment",
        day: "calendar-day",
        death: "dizzy",
        revive: "star-of-life",
        reminder: "sticky-note",
        execution: "vote-yea",
      }
    }
  },
  methods: {
    resetGameLog() {
      this.$store.commit("session/resetGameLog");
    },
    storeNote() {
      const note = {
        type: 'custom',
        text: this.customNote.trim()
      };
      this.customNote = "";
      this.$store.commit("session/addGameLog", note);
    },
    setRecordVoteHistory() {
      this.$store.commit(
        "session/setVoteHistoryAllowed",
        !this.session.isVoteHistoryAllowed
      );
    },
    ...mapMutations(["toggleModal"])
  },
  watch: {
    "grimoire.isNight"(night) {
      const previous = this.session.gameLog.findLast(log => log.type === 'day');
      const num = previous ? previous.num + (previous.d ? 0 : 1) : 0;
      if (!previous || previous.time.getTime() < (Date.now() - 10 * 1000)) {
        this.$store.commit("session/addGameLog", { text: (night ? "Night": "Day") + " " + num + " started", type: "day", d: !night, num: num });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../vars.scss";

.clear {
  position: absolute;
  left: 20px;
  top: 15px;
  cursor: pointer;
  &:hover {
    color: red;
  }
}

.options {
  display: flex;
  justify-content: center;
  align-items: center;
  justify-content: center;
  align-content: center;
}

.option {
  color: white;
  text-decoration: none;
  margin: 0 15px;
  &:hover {
    color: red;
    cursor: pointer;
  }
}

h3 {
  margin: 0 40px 0 10px;
  svg {
    vertical-align: middle;
  }
}

table {
  border-spacing: 10px 0;
  margin-left: auto;
  margin-right: auto;
}

thead td {
  font-weight: bold;
  border-bottom: 1px solid white;
  text-align: center;
  padding: 0 3px;
}

tbody {
  td:nth-child(2) {
    color: $townsfolk;
  }
  td:nth-child(3) {
    color: $demon;
  }
  td:nth-child(5) {
    text-align: center;
  }
  td:nth-child(6) {
    text-align: center;
  }
  td.night hr {
    margin: 0;
    border: none;
    border-top: 1px solid #fff;
  }
}

.controls {
  display: flex;
  padding-top: 5px;

  .customNoteInput {
    border: 2px solid #000;
    border-radius: 7px;
    padding-left: 5px;
  }
}

.log-message {
  font-size: 0.9em;
  padding: 0;
  margin: 3px;
}

.type-day {
  padding-top: 12px;
  font-weight: bold;
  font-size: 1em;
  border-bottom: 1px solid white;
}
.log-wrapper {
  max-height: 60vh;
  overflow-y: auto;
}
</style>
